// extracted by mini-css-extract-plugin
export default {"download-tickets-link":"DownloadTicketsLink_download-tickets-link__n+hrj"};